<template>
  <div class="box">
    <div class="floor1">
      <div class="content">
        <img src="../../assets/img/introduction/yh.svg" alt="" class="yh" />
        <img
          src="../../assets/img/introduction/m1.svg"
          alt=""
          class="descroption"
        />
        <div class="title">Deposit guide</div>
      </div>
    </div>
    <div class="floor2">
      <div class="list">
        <div class="list1_item"></div>
        <div class="list1_item">Current account</div>
        <div class="list1_item">Group savings account</div>
      </div>
      <div class="list list_line">
        <div class="list2_item">APR</div>
        <!-- <div class="list3_item">5%</div>
        <div class="list3_item">6%</div> -->
        <div class="list3_item">4.2%</div>
        <div class="list3_item">5.2%</div>
      </div>
      <div class="list list_line">
        <div class="list2_item">Interest paid</div>
        <div class="list3_item">Monthly</div>
        <div class="list3_item">Monthly</div>
      </div>
      <div class="list list_line">
        <div class="list2_item">Withdraw</div>
        <div class="list3_item">Anytime</div>
        <div class="list3_item">Anytime</div>
      </div>
      <div class="list list_line">
        <div class="list2_item">Deposit</div>
        <div class="list3_item">Anytime</div>
        <div class="list3_item">Anytime</div>
      </div>
      <div class="list">
        <div class="list2_item">Supported Deposit way</div>
        <div class="list3_item">M-pesa</div>
        <div class="list3_item">M-pesa</div>
      </div>
    </div>
    <div class="floor3">
      <!-- Deposit account: wallet, annual interest rate: 5%, interest is paid
      monthly, deposit and withdrawal at any time, support deposit method: mpesa -->
      Deposit account: wallet, annual interest rate: 4.2%, interest is paid
      monthly, deposit and withdrawal at any time, support deposit method: mpesa
      <br /><br />
      <!-- Deposit account: group account, annual interest rate: 6%, interest is paid
      monthly, deposit and withdrawal at any time, support deposit methods
      mpesa, current account.<br /><br /> -->
      Deposit account: group account, annual interest rate: 5.2%, interest is
      paid monthly, deposit and withdrawal at any time, support deposit methods
      mpesa, current account.<br /><br />
      Your group deposits can guarantee loans for yourself and other group
      members.During the guarantee period, the deposit interest is calculated
      and issued normally, and the cash can be withdrawn after the loan is
      repaid.
    </div>
    <div class="el-loading-mask" v-if="!hasToken">
      You are not logged in. Please log in to view the page
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hasToken: false,
    };
  },
  created() {
    let o = this.$route.query;
    if (o.token) {
      this.hasToken = true;
    } else {
      this.hasToken = false;
      return false;
    }
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding-top: 96px;
  padding-bottom: 20px;
  position: relative;
  .floor1 {
    width: 100%;
    height: 300px;
    background: linear-gradient(
      180deg,
      #e1fdff 0%,
      rgba(214, 253, 255, 0) 100%
    );
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    .content {
      width: 100%;
      position: relative;
      .yh {
        position: absolute;
        left: 16px;
        top: 20px;
        z-index: 1;
        height: 40px;
      }
      .descroption {
        position: absolute;
        top: 0;
        right: 16px;
        width: 109px;
      }
      .title {
        position: absolute;
        left: 16px;
        top: 44px;
        font-size: 24px;
        font-family: "rb";
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        z-index: 2;
      }
    }
  }
  .floor2 {
    position: relative;
    margin: 0 16px 16px;
    z-index: 100;
    border-radius: 2px;
    .list {
      display: flex;
      &.list_line {
        border-bottom: 1px solid #e9eff5;
      }
      .list1_item {
        background: #d5fdff;
        display: flex;
        flex: 1;
        font-size: 11px;
        font-family: "rm";
        font-weight: 500;
        color: #303f49;
        height: 48px;
        align-items: center;
        text-align: center;
        justify-content: center;
      }
      .list2_item {
        font-size: 11px;
        font-family: "rm";
        font-weight: 500;
        color: #303f49;
        background: #f5ffff;
        height: 48px;
        align-items: center;
        text-align: center;
        justify-content: center;
        display: flex;
        flex: 1;
      }
      .list3_item {
        font-size: 11px;
        font-family: "rm";
        font-weight: 400;
        color: #50616c;
        background: #ffffff;
        height: 48px;
        align-items: center;
        text-align: center;
        justify-content: center;
        display: flex;
        flex: 1;
      }
    }
  }
  .floor3 {
    margin: 16px;
    padding: 24px 16px;
    font-size: 12px;
    font-family: "rr";
    font-weight: 400;
    color: #50616c;
    line-height: 21px;
    background-color: #ffffff;
  }
}
</style>
